import React, { useCallback } from 'react';
import { FieldValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DocumentTitle from '../../utilComponents/DocumentTitle';
import ResourceFormView from '../../apiForm/scaffold/ResourceFormView';
import useTransactionConfigApi from '../../project/useTransactionConfigApi';
import ReportingForm from './ReportingForm';

export default function ReportingView() {
  const api = useTransactionConfigApi();

  const fetch = useCallback(async () => api.getTransactionConfig(null), [api]);

  const onSubmit = useCallback(
    async (data: FieldValue<any>) => {
      await api.updateTransactionConfig(data);
    },
    [api],
  );
  const { t } = useTranslation();

  return (
    <>
      <DocumentTitle translationID="transactionConfig.reporting.headline" />
      <ResourceFormView
        actionName="reporting"
        Form={ReportingForm}
        fetch={fetch}
        submit={onSubmit}
        headline={t('transactionConfig.reporting.headline')}
      />
    </>
  );
}
